import styled from '@emotion/styled';
import { IGenericCssObject } from './PEEntryNudge';

export const PEEntryNudgeWrapper = styled.div`
  background: ${(props: IGenericCssObject) => props.styles.peEntryNudge?.background};
  @media screen and (min-width:768px) {
    border-radius: ${(props: IGenericCssObject) => props.styles.peEntryNudge?.borderRadius};
    margin: ${(props: IGenericCssObject) => props.styles.peEntryNudge?.margin};
    padding: ${(props: IGenericCssObject) => props.styles.peEntryNudge?.padding};
  }
  @media screen and (max-width:767px) {
    border-radius: ${(props: IGenericCssObject) => props.styles.peEntryNudge?.borderRadiusMobile};
    margin: ${(props: IGenericCssObject) => props.styles.peEntryNudge?.marginMobile};
    padding: ${(props: IGenericCssObject) => props.styles.peEntryNudge?.paddingMobile};
  }
`;

export const Row = styled.div`
  display: ${(props: IGenericCssObject) => props.styles.row?.display};
  align-items: ${(props: IGenericCssObject) => props.styles.row?.alignItems};
`;

export const Column = styled.div`
  padding: ${(props: IGenericCssObject) => props.styles.column?.padding};
  + div {
    flex: 1;
  }
`;

export const LogoWrapper = styled.div`
  background: ${(props: IGenericCssObject) => props.styles.logoWrapper?.background};
  margin: ${(props: IGenericCssObject) => props.styles.logoWrapper?.margin};
  padding: ${(props: IGenericCssObject) => props.styles.logoWrapper?.padding};
  background-size: ${(props: IGenericCssObject) => props.styles.logoWrapper?.backgroundSize};
`;

export const Logo = styled.img`
@media screen and (max-width:767px) {
  width: ${(props: IGenericCssObject) => props.styles.logo?.widthMobile};
  vertical-align: ${(props: IGenericCssObject) => props.styles.logo?.verticalAlignMobile};
}
@media screen and (min-width:768px) {
  margin-bottom: ${(props: IGenericCssObject) => props.styles.logo?.marginBottom};
}
`;

export const Heading = styled.h2`
  font-size: ${(props: IGenericCssObject) => props.styles.heading?.fontSize};
  line-height: ${(props: IGenericCssObject) => props.styles.heading?.lineHeight};
  color: ${(props: IGenericCssObject) => props.styles.heading?.color};
  margin-bottom: ${(props: IGenericCssObject) => props.styles.heading?.marginBottom};
  @media screen and (max-width:767px) {
    font-size: ${(props: IGenericCssObject) => props.styles.heading?.fontSizeMobile};
    line-height: ${(props: IGenericCssObject) => props.styles.heading?.lineHeightMobile};
  }
`;

export const TagText = styled.p`
  font-size: ${(props: IGenericCssObject) => props.styles.tagText?.fontSize};
  line-height: ${(props: IGenericCssObject) => props.styles.tagText?.lineHeight};
  color: ${(props: IGenericCssObject) => props.styles.tagText?.color};
  margin-bottom: ${(props: IGenericCssObject) => props.styles.tagText?.marginBottom};
  @media screen and (max-width:767px) {
    font-size: ${(props: IGenericCssObject) => props.styles.tagText?.fontSizeMobile};
    line-height: ${(props: IGenericCssObject) => props.styles.tagText?.lineHeightMobile};
    margin-bottom: ${(props: IGenericCssObject) => props.styles.tagText?.marginBottomMobile};
  }
`;

export const CtaBtn = styled.a`
  font-size: ${(props: IGenericCssObject) => props.styles.ctaBtn?.fontSize};
  line-height: ${(props: IGenericCssObject) => props.styles.ctaBtn?.lineHeight};
  color: ${(props: IGenericCssObject) => props.styles.ctaBtn?.color};
  display: ${(props: IGenericCssObject) => props.styles.ctaBtn?.display};
  font-weight: ${(props: IGenericCssObject) => props.styles.ctaBtn?.fontWeight};
  text-align: ${(props: IGenericCssObject) => props.styles.ctaBtn?.textAlign};
  background: ${(props: IGenericCssObject) => props.styles.ctaBtn?.background};
  height: ${(props: IGenericCssObject) => props.styles.ctaBtn?.height};
  border-radius: ${(props: IGenericCssObject) => props.styles.ctaBtn?.borderRadius};
  @media screen and (max-width:767px) {
    font-size: ${(props: IGenericCssObject) => props.styles.ctaBtn?.fontSizeMobile};
    height: ${(props: IGenericCssObject) => props.styles.ctaBtn?.heightMobile};
    line-height: ${(props: IGenericCssObject) => props.styles.ctaBtn?.lineHeightMobile};
  }
  position: relative;
  z-index: 1;

  &:before, &:after {
    content: '';
    position: absolute;
    left:0;
    height: 100%;
    border-radius:inherit;
  }

  &:before {
    bottom: 0;
    width: 0%;
    background-color: rgba(26, 26, 26, 0.2);
    transition: all 0.3s;
    z-index: -1;
  }

  &:hover {
    &:before {
      width: 100%;
    }
  }

  &:after {
    width: 100%;
    background-color: #e21b22;
    top: 0;
    z-index: -2;
  }
  &:hover {
    background: white;
  }
`;

